import type React from 'react';
import { SendKommentarModal } from './SendKommentarModal';
import { MenuPopperSendKommentar } from '../MenuPopper/MenuPopperSendKommentar';
import { RolleKommentarList } from './RolleKommentarList';
import type { WithSubComponents } from '@forvalter/utils/TypeScriptUtils';

type SendKommentarSubcomponents = {
    Modal: typeof SendKommentarModal;
    MenuItem: typeof MenuPopperSendKommentar;
    KommentarList: typeof RolleKommentarList;
};

export const SendKommentar: WithSubComponents<
    React.FC,
    SendKommentarSubcomponents
> = () => {
    return null;
};

SendKommentar.Modal = SendKommentarModal;
SendKommentar.MenuItem = MenuPopperSendKommentar;
SendKommentar.KommentarList = RolleKommentarList;
